/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sign_InInputs */

const en_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

const th_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบ`)
};

const ja_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン`)
};

const fr_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se connecter`)
};

const es_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión`)
};

const ru_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Войти`)
};

const zh_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录`)
};

const vi_sign_in = /** @type {(inputs: Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập`)
};

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Sign_InInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const sign_in = /** @type {((inputs?: Sign_InInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sign_InInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_sign_in(inputs)
	if (locale === "ja") return ja_sign_in(inputs)
	if (locale === "fr") return fr_sign_in(inputs)
	if (locale === "es") return es_sign_in(inputs)
	if (locale === "ru") return ru_sign_in(inputs)
	if (locale === "zh") return zh_sign_in(inputs)
	if (locale === "vi") return vi_sign_in(inputs)
	return en_sign_in(inputs)
});